import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./clientTheme.css";
import "./StoreCard.css";

function VerifiedIcon() {
  const { t } = useTranslation("storeCard");
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" className="store-card-verified-icon" aria-label={t("verifiedStore")}>
      <circle cx="12" cy="12" r="12" fill="currentColor" />
      <path d="M7 12.5l3 3 7-7" stroke="#fff" strokeWidth="2.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function PinIcon() {
  return (
    <svg width="11" height="11" viewBox="0 0 24 24" className="store-card-pin-icon" aria-hidden="true">
      <path
        d="M12 22s7-7.05 7-12a7 7 0 1 0-14 0c0 4.95 7 12 7 12z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="10" r="2.5" fill="currentColor" />
    </svg>
  );
}

function FlashIcon({ filled }) {
  return (
    <svg width="11" height="11" viewBox="0 0 24 24" className="store-card-flash-icon" aria-hidden="true">
      <path
        d="M13 2 4 14h6l-1 8 9-12h-6l1-8z"
        fill={filled ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth={filled ? 0 : 2}
        strokeLinejoin="round"
      />
    </svg>
  );
}

function TagIcon() {
  return (
    <svg width="11" height="11" viewBox="0 0 24 24" className="store-card-tag-icon" aria-hidden="true">
      <path
        d="M20 12.5 12.5 20a1.5 1.5 0 0 1-2.12 0l-6.38-6.38a1.5 1.5 0 0 1 0-2.12L11.5 4H19a1 1 0 0 1 1 1v7.5z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <circle cx="15.5" cy="8.5" r="1.5" fill="currentColor" />
    </svg>
  );
}

export default function StoreCard({ store }) {
  const { t } = useTranslation("storeCard");
  const navigate = useNavigate();
  const city = store.cityNameEnglish || store.city;
  const rating = Number(store.rating ?? 0);

  return (
    <div className="store-card" onClick={() => navigate(`/products?storeId=${store.storeId}`)}>
      <div className="store-card-cover-wrap">
        <div className="store-card-cover">
          {store.coverImageUrl ? (
            <img src={store.coverImageUrl} alt="" className="store-card-cover-image" />
          ) : (
            <div className="store-card-cover-placeholder" />
          )}
        </div>

        {store.hasActiveCoupons && (
          <span className="store-card-coupon-badge" aria-label={t("activeDeals")}>
            <TagIcon />
          </span>
        )}

        {store.isPrime && (
          <span className="store-card-prime-badge">
            <FlashIcon filled />
            {t("prime")}
          </span>
        )}

        <div className="store-card-logo-ring">
          {store.logoUrl ? (
            <img src={store.logoUrl} alt="" className="store-card-logo" />
          ) : (
            <div className="store-card-logo store-card-logo-placeholder">{store.storeName.charAt(0)}</div>
          )}
        </div>
      </div>

      <div className="store-card-info">
        <div className="store-card-name-row">
          <span className="store-card-name">{store.storeName}</span>
          {store.isApproved && <VerifiedIcon />}
        </div>

        {city && (
          <div className="store-card-meta-row">
            <PinIcon />
            <span className="store-card-city">{city}</span>
          </div>
        )}

        {store.isPrime && (
          <div className="store-card-meta-row">
            <FlashIcon />
            <span className="store-card-prime-note">{t("primeDelivery")}</span>
          </div>
        )}

        <div className="store-card-footer">
          <span className="store-card-rating">
            <span className="store-card-star">★</span> {rating.toFixed(1)}
          </span>
        </div>
      </div>
    </div>
  );
}
